import React, { useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import { passwordRecoveryApiService } from '../services/apiServices';

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (newPassword !== newPasswordConfirm) {
      setError('Пароли не совпадают');
      return;
    }

    if (newPassword.length < 8) {
      setError('Пароль должен содержать минимум 8 символов');
      return;
    }

    if (!token) {
      setError('Токен восстановления отсутствует');
      return;
    }

    setLoading(true);
    try {
      await passwordRecoveryApiService.completeRecovery(token, newPassword, newPasswordConfirm);
      setSuccess(true);
    } catch (err: any) {
      const body = err?.body as { code?: string; message?: string } | undefined;
      if (body?.code === 'password_auth_recovery_token_not_found') {
        setError('Ссылка для восстановления истекла или недействительна. Запросите новую.');
      } else if (body?.code === 'no_password_auth') {
        setError('Для вашего аккаунта не настроена аутентификация по паролю');
      } else if (body?.code === 'password_auth_recovery_rate_limited') {
        setError('Слишком много запросов. Попробуйте позже');
      } else {
        setError(body?.message || 'Ошибка при восстановлении пароля');
      }
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <Card className="shadow w-100" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <Card.Header className="bg-primary text-white text-center py-3">
          <Card.Title className="mb-0">
            <h3 className="mb-0">Сброс пароля</h3>
          </Card.Title>
        </Card.Header>
        <Card.Body className="p-4 text-center">
          <Alert variant="danger">Ссылка для восстановления пароля недействительна.</Alert>
          <Link to="/forgot-password" className="btn btn-primary">
            Запросить новую ссылку
          </Link>
        </Card.Body>
      </Card>
    );
  }

  if (success) {
    return (
      <Card className="shadow w-100" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <Card.Header className="bg-primary text-white text-center py-3">
          <Card.Title className="mb-0">
            <h3 className="mb-0">Сброс пароля</h3>
          </Card.Title>
        </Card.Header>
        <Card.Body className="p-4 text-center">
          <Alert variant="success">
            Пароль успешно изменён. Теперь вы можете войти с новым паролем.
          </Alert>
          <Link to="/login" className="btn btn-primary">
            Войти
          </Link>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="shadow w-100" style={{ maxWidth: '400px', margin: '0 auto' }}>
      <Card.Header className="bg-primary text-white text-center py-3">
        <Card.Title className="mb-0">
          <h3 className="mb-0">Сброс пароля</h3>
        </Card.Title>
      </Card.Header>
      <Card.Body className="p-4">
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formNewPassword">
            <Form.Label className="fw-bold">Новый пароль</Form.Label>
            <Form.Control
              type="password"
              placeholder="Введите новый пароль"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={8}
              disabled={loading}
              className="py-2"
            />
          </Form.Group>

          <Form.Group className="mb-4" controlId="formNewPasswordConfirm">
            <Form.Label className="fw-bold">Подтверждение пароля</Form.Label>
            <Form.Control
              type="password"
              placeholder="Повторите новый пароль"
              value={newPasswordConfirm}
              onChange={(e) => setNewPasswordConfirm(e.target.value)}
              required
              minLength={8}
              disabled={loading}
              className="py-2"
            />
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="w-100 py-2 fw-semibold"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Сохранение...
              </>
            ) : (
              'Установить пароль'
            )}
          </Button>
        </Form>

        <div className="text-center mt-3">
          <Link to="/login" className="text-decoration-none">
            Вернуться к входу
          </Link>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ResetPasswordPage;
